import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as L } from "../../_mixins/use-rtl.js";
import H from "./styles/index.cssr.js";
import O from "../../_mixins/use-config.js";
import v from "../../_mixins/use-theme.js";
import { getMargin as T } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { createKey as l } from "../../_utils/cssr/index.js";
import { useThemeClass as N } from "../../_mixins/use-css-vars-class.js";
import j from "../../_internal/close/src/Close.js";
import { resolveSlot as F, resolveWrappedSlot as M } from "../../_utils/vue/resolve-slot.js";
import k from "../../_internal/fade-in-expand-transition/src/FadeInExpandTransition.js";
import { warnOnce as V } from "../../_utils/naive/warn.js";
import W from "../styles/light.js";
import D from "../../_internal/icon/src/Icon.js";
import K from "../../_internal/icons/Error.js";
import q from "../../_internal/icons/Warning.js";
import G from "../../_internal/icons/Info.js";
import J from "../../_internal/icons/Success.js";
import { defineComponent as Q, watchEffect as U, computed as g, h as t, mergeProps as X } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as Y } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const Z = Object.assign(Object.assign({}, v.props), {
  title: String,
  showIcon: {
    type: Boolean,
    default: !0
  },
  type: {
    type: String,
    default: "default"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  onClose: Function,
  onAfterLeave: Function,
  /** @deprecated */
  onAfterHide: Function
}), Ie = Q({
  name: "Alert",
  inheritAttrs: !1,
  props: Z,
  slots: Object,
  setup(r) {
    process.env.NODE_ENV !== "production" && U(() => {
      r.onAfterHide !== void 0 && V("alert", "`on-after-hide` is deprecated, please use `on-after-leave` instead.");
    });
    const {
      mergedClsPrefixRef: e,
      mergedBorderedRef: i,
      inlineThemeDisabled: d,
      mergedRtlRef: f
    } = O(r), a = v("Alert", "-alert", H, W, r, e), p = L("Alert", f, e), m = g(() => {
      const {
        common: {
          cubicBezierEaseInOut: s
        },
        self: o
      } = a.value, {
        fontSize: C,
        borderRadius: R,
        titleFontWeight: A,
        lineHeight: I,
        iconSize: y,
        iconMargin: h,
        iconMarginRtl: $,
        closeIconSize: _,
        closeBorderRadius: x,
        closeSize: z,
        closeMargin: B,
        closeMarginRtl: P,
        padding: w
      } = o, {
        type: n
      } = r, {
        left: E,
        right: S
      } = T(h);
      return {
        "--n-bezier": s,
        "--n-color": o[l("color", n)],
        "--n-close-icon-size": _,
        "--n-close-border-radius": x,
        "--n-close-color-hover": o[l("closeColorHover", n)],
        "--n-close-color-pressed": o[l("closeColorPressed", n)],
        "--n-close-icon-color": o[l("closeIconColor", n)],
        "--n-close-icon-color-hover": o[l("closeIconColorHover", n)],
        "--n-close-icon-color-pressed": o[l("closeIconColorPressed", n)],
        "--n-icon-color": o[l("iconColor", n)],
        "--n-border": o[l("border", n)],
        "--n-title-text-color": o[l("titleTextColor", n)],
        "--n-content-text-color": o[l("contentTextColor", n)],
        "--n-line-height": I,
        "--n-border-radius": R,
        "--n-font-size": C,
        "--n-title-font-weight": A,
        "--n-icon-size": y,
        "--n-icon-margin": h,
        "--n-icon-margin-rtl": $,
        "--n-close-size": z,
        "--n-close-margin": B,
        "--n-close-margin-rtl": P,
        "--n-padding": w,
        "--n-icon-margin-left": E,
        "--n-icon-margin-right": S
      };
    }), c = d ? N("alert", g(() => r.type[0]), m, r) : void 0, u = Y(!0), b = () => {
      const {
        onAfterLeave: s,
        onAfterHide: o
        // deprecated
      } = r;
      s && s(), o && o();
    };
    return {
      rtlEnabled: p,
      mergedClsPrefix: e,
      mergedBordered: i,
      visible: u,
      handleCloseClick: () => {
        var s;
        Promise.resolve((s = r.onClose) === null || s === void 0 ? void 0 : s.call(r)).then((o) => {
          o !== !1 && (u.value = !1);
        });
      },
      handleAfterLeave: () => {
        b();
      },
      mergedTheme: a,
      cssVars: d ? void 0 : m,
      themeClass: c == null ? void 0 : c.themeClass,
      onRender: c == null ? void 0 : c.onRender
    };
  },
  render() {
    var r;
    return (r = this.onRender) === null || r === void 0 || r.call(this), t(k, {
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => {
        const {
          mergedClsPrefix: e,
          $slots: i
        } = this, d = {
          class: [
            `${e}-alert`,
            this.themeClass,
            this.closable && `${e}-alert--closable`,
            this.showIcon && `${e}-alert--show-icon`,
            // fix: https://github.com/tusen-ai/naive-ui/issues/4588
            !this.title && this.closable && `${e}-alert--right-adjust`,
            this.rtlEnabled && `${e}-alert--rtl`
          ],
          style: this.cssVars,
          role: "alert"
        };
        return this.visible ? t("div", Object.assign({}, X(this.$attrs, d)), this.closable && t(j, {
          clsPrefix: e,
          class: `${e}-alert__close`,
          onClick: this.handleCloseClick
        }), this.bordered && t("div", {
          class: `${e}-alert__border`
        }), this.showIcon && t("div", {
          class: `${e}-alert__icon`,
          "aria-hidden": "true"
        }, F(i.icon, () => [t(D, {
          clsPrefix: e
        }, {
          default: () => {
            switch (this.type) {
              case "success":
                return t(J, null);
              case "info":
                return t(G, null);
              case "warning":
                return t(q, null);
              case "error":
                return t(K, null);
              default:
                return null;
            }
          }
        })])), t("div", {
          class: [`${e}-alert-body`, this.mergedBordered && `${e}-alert-body--bordered`]
        }, M(i.header, (f) => {
          const a = f || this.title;
          return a ? t("div", {
            class: `${e}-alert-body__title`
          }, a) : null;
        }), i.default && t("div", {
          class: `${e}-alert-body__content`
        }, i))) : null;
      }
    });
  }
});
export {
  Z as alertProps,
  Ie as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/alert/src/Alert.js
// module id = 1585
// module chunks = 41